// import React from "react";

// const processSteps = [
//   { icon: "icon-17", title: "Sign up Account", link: "#" },
//   { icon: "icon-18", title: "Search your Vehicle", link: "#" },
//   { icon: "icon-19", title: "Pay the Car Rent", link: "#" },
//   { icon: "icon-20", title: "Take Car to Road", link: "#" },
// ];

// const WorksProcessSection = () => {
//   return (
//     <section className="works-process-section pb_90 inner-page">
//       <div className="container">
//         <div className="section-title centred mb_60">
//           <span className="sub-title">Popular Cars</span>
//           <h2 className="title">How it works</h2>
//         </div>
//         <div className="row">
//           {processSteps.map(({ icon, title, link }, index) => (
//             <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 colmun" key={index}>
//               <div className="works-process-block centred">
//                 <div className="works-process-block-icon">
//                   <i className={icon}></i>
//                 </div>
//                 <h3 className="works-process-block-title">
//                   <a href={link}>{title}</a>
//                 </h3>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WorksProcessSection;



import React from "react";

const processSteps = [
  {
    number: "1",
    icon: "fa-solid fa-route",
    title: "Select Your Trip",
    color: "#f39c12",
  },
  {
    number: "2",
    icon: "fa-solid fa-car-side",
    title: "Choose Vehicle Type",
    color: "#7d4bdb",
  },
  {
    number: "3",
    icon: "fa-solid fa-handshake",
    title: "Confirm & Connect",
    color: "#4CAF50",
  },
  {
    number: "4",
    icon: "fa-solid fa-location-dot",
    title: "Enjoy Your Journey",
    color: "#ffb84d",
  },
];

const WorksProcessSection = () => {
  return (
    <section className="works-process-section pb_90 inner-page">
      <div className="container">
        <div className="section-title centred mb_60">
          <span className="sub-title">POPULAR CARS</span>
          <h2 className="title">How It Works</h2>
        </div>

        <div className="row justify-content-center">
          {processSteps.map((step, index) => (
            <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12" key={index}>
              <div
                className="process-card text-center"
                style={{ borderColor: step.color }}
              >
                <div className="process-icon" style={{ backgroundColor: step.color }}>
                  <span className="process-number">{step.number}</span>
                  <i className={step.icon}></i>
                </div>
                <h4 className="process-title">{step.title}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorksProcessSection;
